import { Button } from '@mint-lib/tw-components';

import { Separator } from './Separator.jsx';

type SecondaryButtonProps = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  disabled?: boolean;
  separator?: boolean;
};

export function SecondaryButton({
  label,
  onClick,
  icon,
  disabled,
  separator,
}: Readonly<SecondaryButtonProps>) {
  return (
    <>
      <Button variant="outlined" onClick={onClick} disabled={disabled}>
        {icon}
        {label}
      </Button>
      {separator && <Separator />}
    </>
  );
}
